import { Url } from '../shared/Url';
import Post from '../shared/Post';

import { cookieData } from '../funciones/ConsultaUser';

export const RegistraUsuario = (user, pass, utype, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            User: user,
            Pass: pass,
            UType: utype,
            usu: cookie[1]
        }

        Post(`${Url}addUserDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    })
}

export const BuscaUsuario = (email, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            email: email,
            usu: cookie[1]
        }

        Post(`${Url}searchUserDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    })
}

export const EditarUsuario = (id, usuario, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            email: usuario,
            usu: cookie[1]
        }

        Post(`${Url}editUserDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    })
}


// WEBPACK FOOTER //
// ./src/funciones/UsuariosFunctions.jsx